import moment from "moment";

const monthOptions = (function () {
  return Array(12)
    .fill(null)
    .map((_, i) => ({ label: moment.months(i), value: i }));
})();

const yearOptions = (function () {
  const years = [];
  const startYear = new Date().getFullYear();
  for (let i = startYear; i > startYear - 50; i--)
    years.push({ label: i, value: i });
  return years;
})();

const dateDifference = (date1, date2) => {
  if (!date1) return;
  if (!date2) date2 = moment();

  const years = date2.diff(date1, "year");
  date1.add(years, "years");

  const months = date2.diff(date1, "months");
  date1.add(months, "months");

  let output = "";

  if (years > 0) output = `${years}yr `;

  output += `${months}mos`;

  return output;
};

const isDayInYear = ({ momentMinDate, momentMaxDate, momentEndDate }) => {
  const moment1 = moment(momentMinDate);
  const moment2 = moment(momentMaxDate);
  const moment3 = moment(momentEndDate);
  return moment3.isBetween(moment1, moment2, "days", "[]");
};

/**
 * This function will return duration between 2 dates
 * This duration is based on "durationIn" param
 *
 * @param {*} param0
 * @param {String} param0.startDate - Start date of duration
 * @param {String} param0.endDate - End date of duration
 * @param {String} param0.durationIn - Type of duration we want it can be one of following:
 * years, months, weeks, days, hours, minutes, and seconds
 *
 * @returns {Number} - Returns duration
 */
const getDurationFromDates = ({ startDate, endDate, durationIn = "weeks" }) => {
  const startDateObj = moment(startDate),
    /*
     * need to add 1 day because for start data it will take start time of day and for end data also it will take the start time of day
     * so in that case diff will have 1 day less and if for end time we are taking end time of day it will give 0.99 as a
     * diff and when we take its floor the value will be 1 less than its original result
     */
    endDateObj = moment(endDate).add(1, "days");
  return endDateObj.diff(startDateObj, durationIn);
};

export {
  monthOptions,
  yearOptions,
  dateDifference,
  isDayInYear,
  getDurationFromDates,
};
